import type { MouseEventHandler, ReactNode } from 'react';
import type { ModalData } from '..';

export interface CheckoutConfirmationModalData {
  modal: ModalData;
  onConfirm?: MouseEventHandler;
  illustration?: ReactNode;
  loading?: boolean;
  priceValue: number;
}

export interface CheckoutConfirmationModalProps extends CheckoutConfirmationModalData {}
